function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000976562,
  width: 35.0005,
  height: 35,
  rx: 3,
  fill: "#201D2F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.443 25.2592C28.443 24.8502 28.1113 24.5185 27.7022 24.5185H25.666L27.3715 18.5492C27.4354 18.3257 27.3906 18.0852 27.2506 17.8996C27.1107 17.714 26.8917 17.6049 26.6593 17.6049H25.4741V13.2099C25.4741 12.8008 25.1424 12.4691 24.7333 12.4691C24.3243 12.4691 23.9926 12.8008 23.9926 13.2099V17.6049H22.2148C22.0998 17.6049 21.9864 17.6317 21.8836 17.6831L20.0647 18.5926H7.73976C7.50164 18.5926 7.27809 18.707 7.13888 18.9002C6.99967 19.0933 6.96179 19.3416 7.03705 19.5675L8.68737 24.5185H7.73976C7.33068 24.5185 6.99902 24.8502 6.99902 25.2592C6.99902 25.6683 7.33068 26 7.73976 26H27.7022C28.1113 26 28.443 25.6683 28.443 25.2592ZM19.7457 21.5555H21.2272C21.6363 21.5555 21.9679 21.8872 21.9679 22.2963C21.9679 22.7054 21.6363 23.037 21.2272 23.037H19.7457C19.3366 23.037 19.005 22.7054 19.005 22.2963C19.005 21.8872 19.3366 21.5555 19.7457 21.5555ZM15.3012 21.5555H16.7827C17.1918 21.5555 17.5235 21.8872 17.5235 22.2963C17.5235 22.7054 17.1918 23.037 16.7827 23.037H15.3012C14.8922 23.037 14.5605 22.7054 14.5605 22.2963C14.5605 21.8872 14.8922 21.5555 15.3012 21.5555ZM10.8568 21.5555H12.3383C12.7474 21.5555 13.079 21.8872 13.079 22.2963C13.079 22.7054 12.7474 23.037 12.3383 23.037H10.8568C10.4477 23.037 10.1161 22.7054 10.1161 22.2963C10.1161 21.8872 10.4477 21.5555 10.8568 21.5555Z",
  fill: "#F0F0F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5194 13.358V12.6173C17.5194 12.2082 17.1877 11.8765 16.7786 11.8765H15.0502V10.7407C15.0502 10.3317 14.7186 10 14.3095 10C13.9004 10 13.5687 10.3317 13.5687 10.7407V11.8765H11.8404C11.4313 11.8765 11.0996 12.2082 11.0996 12.6173V13.358H17.5194Z",
  fill: "#F0F0F5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0009 15.5802C19.0009 15.1712 18.6692 14.8395 18.2601 14.8395H10.3589C9.94982 14.8395 9.61816 15.1712 9.61816 15.5802V16.8148H19.0009V15.5802Z",
  fill: "#F0F0F5"
});

function SvgVesselMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselMap);
export default __webpack_public_path__ + "static/media/vessel-map.f2478525.svg";
export { ForwardRef as ReactComponent };